module.exports = __webpack_public_path__ + "static/media/sandra.4315f692.jpg";